import mutations from './treatmentSelect.mutations'
import actions from './treatmentSelect.actions'
import getters from './treatmentSelect.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
